// src/features/agent-builder/components/PromptCopilotTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button, Tooltip } from '@dopomogai/ui';
import clsx from 'clsx';

export const PromptCopilotTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div
      className={clsx(
        "mt-4 p-4 bg-slate-50 rounded-lg",
        // Neobrutalist border:
        "border-2 border-black"
        // This small, static info/teaser box typically wouldn't have its own hover shadow.
        // Opacity/disabled state for buttons is handled by the buttons themselves.
      )}
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 pt-0.5">
          <Sparkles size={20} className="text-indigo-500" aria-hidden="true" />
        </div>
        <div>
          <p className="text-sm font-medium text-slate-700">
            {t('step2.promptCopilot.helpText')}
          </p>
          <div className="mt-2 flex flex-col sm:flex-row gap-2">
            <Tooltip
              textKey="agentBuilder:step2.promptCopilot.enhanceTooltip"
            >
              <Button
                textKey="agentBuilder:step2.promptCopilot.enhanceButton"
                variant="secondary" // Assuming secondary still has Neobrutalist structure
                size="sm"
                disabled
                icon={<Sparkles size={14} />}
                // The Button component should handle its disabled styling (opacity).
                // If specific `opacity-70 cursor-not-allowed` is still needed ON TOP of Button's
                // disabled style, it can be added via `className`.
                // For a true Neobrutalist disabled button, it might lose its shadow/translation.
              />
            </Tooltip>
            <Tooltip
              textKey="agentBuilder:step2.promptCopilot.createTooltip"
            >
              <Button
                textKey="agentBuilder:step2.promptCopilot.createButton"
                variant="secondary"
                size="sm"
                disabled
                icon={<Sparkles size={14} />}
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};